import { z } from "zod";

export const periodSchema = z.union([z.literal(7), z.literal(30), z.literal(90)]);

export const applicationStatusCountsSchema = z.object({
  TAILORING: z.number().int(),
  REVIEWING: z.number().int(),
  QUEUED: z.number().int(),
  APPLYING: z.number().int(),
  APPLIED: z.number().int(),
  VIEWED: z.number().int(),
  SCREEN: z.number().int(),
  FAILED: z.number().int(),
  SKIPPED: z.number().int(),
  INTERVIEW: z.number().int(),
  OFFER: z.number().int(),
  REJECTED: z.number().int(),
  GHOSTED: z.number().int(),
  NEEDS_ATTENTION: z.number().int(),
  // Kept exhaustive over the Prisma ApplicationStatus enum on purpose: StatsService seeds this
  // object from Object.values(ApplicationStatus) and casts to this type, so a missing key here is
  // the one compile error that catches an enum growing. Adding a value without adding it here
  // fails typecheck rather than silently shipping an unindexable counter.
  ACCEPTED: z.number().int(),
  WITHDRAWN: z.number().int(),
  EXPIRED: z.number().int(),
});

export const dailyCountSchema = z.object({
  date: z.string(),
  count: z.number().int(),
});

export const statsResponseSchema = z.object({
  period: periodSchema,
  applications: z.object({
    total: z.number().int(),
    byStatus: applicationStatusCountsSchema,
    dailyCounts: z.array(dailyCountSchema),
  }),
  resumes: z.object({
    total: z.number().int(),
    byVisibility: z.object({ public: z.number().int(), private: z.number().int() }),
    totalViews: z.number().int(),
    totalDownloads: z.number().int(),
  }),
  jobSearches: z.object({
    total: z.number().int(),
    byStatus: z.object({
      PENDING: z.number().int(),
      IN_PROGRESS: z.number().int(),
      COMPLETED: z.number().int(),
      FAILED: z.number().int(),
    }),
  }),
  aiUsage: z.object({
    tailoringsUsedToday: z.number().int(),
    tailoringsPerDayLimit: z.number().int(),
    applicationsUsedThisMonth: z.number().int(),
    applicationsLimit: z.number().int(),
  }),
});

export type Period = z.infer<typeof periodSchema>;
export type StatsResponse = z.infer<typeof statsResponseSchema>;
